export const DOWNLOAD_URL = 'https://qp-india.s3.ap-south-1.amazonaws.com/apk/RummyRun-release.apk'
export const FB_PIXEL_ACCESS_TOKENS = {
  '1799564210786801':
    'EAA3I0OAWmv4BO9hdNPL1m911jo9pqhjufXwXpwNpY2LMgslpUZCGcST4Yal1pZBBOPyvWdKZC3GfBjuglLPL8ds6HTihRXEpqVKb3E3zRjSviBPWW8HtBDp49fBoxRnuDdNZCYB1vAs0j9YFzCxdsiXnS1OywMZCi7RMFUkzoXKJvSED6E6NZAIfgrPQ94nW8DkgZDZD',
  '1075800140650610':
    'EAAOcH08xU6oBOZBnmojAImuc2QazBkObMuaY9eqsIuIkl9aadYNDc4zNqQOdvGTAOZAQyHBC6kFsGv2YNZA2p8NDMk4SaoUggyecQ5E98H14eOeV3CuJKGNFnZCS0ZAarbYAAbZB3MUdCdX04U93ONtpQejVGzA7p9hcj30coMB1TtdWbZAPP23FVuU3nU3ZCKUOsgZDZD',
}
